import { alpha, createTheme } from "@mui/material";

// Shared sx snippet: keeps an element scrollable via touch/wheel while hiding the
// visual scrollbar. Applied to the auth-card scroll region so tall forms don't show
// the (globally styled) scrollbar. Dashboard scrollbars are unaffected.
export const hideScrollbar = {
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": { display: "none" },
};

// Soft elevation used by auth cards/dialogs, mode-aware.
export const authCardShadow = (theme) =>
  theme.palette.mode === "light"
    ? `0 8px 32px ${alpha(theme.palette.common.black, 0.1)}`
    : `0 8px 32px ${alpha(theme.palette.common.black, 0.4)}`;

export const getTheme = (mode) => createTheme({
  palette: {
    mode,
    primary: {
      main: "#FFAA00",
      light: "#FFCC66",
      dark: "#CC8800",
      lighter: mode === 'light' ? "rgba(255, 170, 0, 0.08)" : "rgba(255, 170, 0, 0.15)",
      contrastText: "#fff"
    },
    secondary: {
      main: mode === 'light' ? "#1D2426" : "#E4E6E7",
    },
    background: {
      default: mode === 'light' ? "#fcfcfc" : "#0A0A0A",
      paper: mode === 'light' ? "#fff" : "#141414",
    },
    text: {
      primary: mode === 'light' ? "#1D2426" : "#F5F5F5",
      secondary: mode === 'light' ? "rgba(29, 36, 38, 0.7)" : "rgba(245, 245, 245, 0.7)",
      disabled: mode === 'light' ? "rgba(29, 36, 38, 0.38)" : "rgba(245, 245, 245, 0.38)",
    },
    divider: mode === 'light' ? "rgba(0, 0, 0, 0.08)" : "rgba(255, 255, 255, 0.08)",
    google: {
      main: "#4185f4"
    },
    facebook: {
      main: "#1877F2"
    }
  },
  shape: {
    borderRadius: 12
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollbarColor: mode === 'dark' ? "#6b6b6b #2b2b2b" : "#959595 #f1f1f1",
          transition: 'background-color 0.3s ease, color 0.3s ease',
          "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
            backgroundColor: mode === 'dark' ? "#2b2b2b" : "#f1f1f1",
            width: '8px',
            height: '8px',
          },
          "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
            borderRadius: 8,
            backgroundColor: mode === 'dark' ? "#6b6b6b" : "#959595",
            border: mode === 'dark' ? "3px solid #2b2b2b" : "3px solid #f1f1f1",
          },
          "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
            backgroundColor: mode === 'dark' ? "#959595" : "#6b6b6b",
          },
          "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
            backgroundColor: mode === 'dark' ? "#959595" : "#6b6b6b",
          },
          "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
            backgroundColor: mode === 'dark' ? "#959595" : "#6b6b6b",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none'
        }
      }
    }
  },
});
